import { render, staticRenderFns } from "./CardRealtime.vue?vue&type=template&id=f1f8db86&scoped=true"
import script from "./CardRealtime.vue?vue&type=script&lang=js"
export * from "./CardRealtime.vue?vue&type=script&lang=js"
import style0 from "./CardRealtime.vue?vue&type=style&index=0&id=f1f8db86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f8db86",
  null
  
)

export default component.exports